<arm-layout>
    <div header>
        <div class="search-container">
            <arm-search [searchComponent]="routingGroupsSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms"
                        (onSearch)="onSearch($event)">
            </arm-search>
        </div>

        <div class="action-buttons">
            <arm-action-bar (editClick)="editItem()" [disableEdit]="isUnauthorized || !this.isSingleSelection()"
                            (deleteClick)="removeItem()" [disableDelete]="isUnauthorized || !this.isSingleSelection()"
                            (refreshClick)="refresh()">
            </arm-action-bar>

            <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button [matMenuTriggerFor]="liveMenu" mat-menu-item
                        [disabled]="isUnauthorized || !this.isSingleSelection()">
                    <span>Live</span>
                </button>
                <button mat-menu-item (click)="duplicateRule()"
                        [disabled]="isUnauthorized || !this.isSingleSelection()">
                    <span>Duplicate</span>
                </button>
                <button mat-menu-item (click)="moveRule()"
                        [disabled]="isUnauthorized || !this.isSingleSelection()">
                    <span>Move</span>
                </button>
                <button mat-menu-item (click)="openColumnsConfiguration()">
                    <span>Table columns</span>
                </button>
            </mat-menu>

            <mat-menu #liveMenu="matMenu">
                <button mat-menu-item (click)="toggleLock('unlock')"
                        [disabled]="isUnauthorized || !this.isSingleSelection() || !onlyLockedItemsSelected">
                    <span>True</span>
                </button>
                <button mat-menu-item (click)="toggleLock('lock')"
                        [disabled]="isUnauthorized || !this.isSingleSelection() || !onlyUnlockedItemsSelected">
                    <span>False</span>
                </button>
            </mat-menu>
        </div>
    </div>

    <div main>
        <arm-table [displayedColumns]="displayedColumns" (pageChanged)="pageChanged($event)"
                   (onSelection)="onSelection($event)" [data]="data.elements" [length]="data.totalElements"
                   [isMultipleSelection]="true" [isClientSide]="false">
        </arm-table>
    </div>
</arm-layout>
